import { Modal } from "../ui/Modal";
import { MemoryRouter } from "react-router-dom";
import { StudentDashboard } from "../../pages/student/Dashboard";
import { StudentProvider } from "../../context/StudentContext";
import type { AdminUser } from "../../lib/api";

type Props = {
  user: AdminUser;
  onClose: () => void;
};

export function StudentPreviewModal({ user, onClose }: Props) {
  return (
    <Modal
      isOpen
      onClose={onClose}
      size="full"
      title={`Previewing ${user.name}`}
      description="Read-only simulation. The admin page remains open underneath."
    >
          <MemoryRouter initialEntries={["/student"]}>
            <StudentProvider>
              <StudentDashboard previewUserId={user.id} />
            </StudentProvider>
          </MemoryRouter>
    </Modal>
  );
}
